import script from "./sf-dropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./sf-dropdown.vue?vue&type=script&setup=true&lang=ts"

import "./sf-dropdown.vue?vue&type=style&index=0&id=f9a7e8d7&lang=scss"

const __exports__ = script;

export default __exports__